/* =============================================================================
 longFeatures — mobile: клонований sticky thead + горизонтальний скрол
 Підключити ПІСЛЯ pricePage.js
 ============================================================================= */
(function () {

	var BREAKPOINT = 1024;
	var mql = window.matchMedia('(max-width: ' + BREAKPOINT + 'px)');

	var lf, table, thead, clone;
	var syncing = false;
	var resizeRAF = 0;

	function px(v) { return Math.round(v) + 'px'; }

	/* Скопіювати ширини колонок з оригінальних th на клоновані */
	function syncColWidths() {
		if (!clone || !thead) return;
		var cloneThs = clone.querySelectorAll('th');
		var cloneTable = clone.querySelector('table');

		/* Скинемо фіксовані ширини на клоні */
		for (var i = 0; i < cloneThs.length; i++) {
			cloneThs[i].style.width = '';
			cloneThs[i].style.minWidth = '';
		}
		if (cloneTable) {
			cloneTable.style.width = '';
			cloneTable.style.minWidth = '';
		}

		/*
		 * Вимірюємо ширини з першого НЕ-group рядка tbody.
		 * Ці td мають реальні ширини, задані контентом і table layout.
		 * Thead visibility:hidden, тому його th стиснуті — міряти їх не можна.
		 */
		var refRow = table.querySelector('tbody tr:not(.group)');
		if (!refRow) return;
		var refCells = refRow.querySelectorAll('td');
		var widths = [];
		for (var i = 0; i < refCells.length; i++) {
			widths.push(refCells[i].getBoundingClientRect().width);
		}
		var totalW = table.offsetWidth;

		/* Встановимо ширини на клон */
		var count = Math.min(cloneThs.length, widths.length);
		for (var i = 0; i < count; i++) {
			cloneThs[i].style.width = px(widths[i]);
			cloneThs[i].style.minWidth = px(widths[i]);
			cloneThs[i].style.boxSizing = 'border-box';
		}
		if (cloneTable) {
			cloneTable.style.width = px(totalW);
			cloneTable.style.minWidth = px(totalW);
		}

		/* Негативний margin = висота клона, щоб перекривав оригінальний thead */
		clone.style.marginBottom = -clone.offsetHeight + 'px';
	}

	/* ── Створити клон ── */
	function createClone() {
		if (clone) return;

		lf = document.getElementById('longFeatures');
		if (!lf) return;
		table = lf.querySelector('table');
		thead = table ? table.querySelector('thead') : null;
		if (!table || !thead) return;

		/* Обгортка */
		clone = document.createElement('div');
		clone.className = 'lf-stickyThead';

		/* Клонуємо thead у нову таблицю */
		var cloneTable = document.createElement('table');
		var cloneThead = thead.cloneNode(true);
		cloneThead.style.visibility = '';
		cloneThead.classList.remove('is-stick');
		cloneTable.appendChild(cloneThead);
		clone.appendChild(cloneTable);

		/* Вставляємо перед .longFeatures */
		lf.parentNode.insertBefore(clone, lf);

		/* Позначаємо що клон є — CSS сховає оригінальний thead */
		lf.classList.add('has-cloned-thead');

		syncColWidths();

		/* Горизонтальний скрол sync */
		lf.addEventListener('scroll', onLfScroll, { passive: true });
		clone.addEventListener('scroll', onCloneScroll, { passive: true });

		updateScrolledX();
	}

	/* ── Знищити клон ── */
	function destroyClone() {
		if (!clone) return;
		lf.removeEventListener('scroll', onLfScroll);
		clone.removeEventListener('scroll', onCloneScroll);
		clone.parentNode.removeChild(clone);
		clone = null;
		if (lf) lf.classList.remove('has-cloned-thead');
	}

	/* ── Горизонтальний скрол sync ── */
	function onLfScroll() {
		if (syncing) return;
		syncing = true;
		if (clone) clone.scrollLeft = lf.scrollLeft;
		updateScrolledX();
		syncing = false;
	}
	function onCloneScroll() {
		if (syncing) return;
		syncing = true;
		if (lf) lf.scrollLeft = clone.scrollLeft;
		updateScrolledX();
		syncing = false;
	}

	function updateScrolledX() {
		if (!lf) return;
		var scrolled = lf.scrollLeft > 2;
		lf.classList.toggle('is-scrolled-x', scrolled);
		if (clone) clone.classList.toggle('is-scrolled-x', scrolled);
	}

	/* ── Resize ── */
	function onResize() {
		if (resizeRAF) return;
		resizeRAF = requestAnimationFrame(function () {
			resizeRAF = 0;
			if (mql.matches) {
				if (!clone) createClone();
				else syncColWidths();
			} else {
				destroyClone();
			}
		});
	}

	/* ── Патч _calcAndApply: toggle .is-stick на клоні ── */
	function patchCalcAndApply() {
		if (!App || !App.page || !App.page._calcAndApply) return;

		var original = App.page._calcAndApply.bind(App.page);

		App.page._calcAndApply = function () {
			original();

			if (!clone || !mql.matches) return;

			var header = document.querySelector('.section-header');
			if (!header) return;

			var lfEl = document.getElementById('longFeatures');
			if (!lfEl || lfEl.classList.contains('collapsed')) {
				clone.classList.add('lf-hidden');
				return;
			}
			clone.classList.remove('lf-hidden');

			var headerH = header.getBoundingClientRect().height || 0;
			var sentinel = lfEl.querySelector('.longFeatures__sentinel');
			if (!sentinel) return;

			var sentinelTop = sentinel.getBoundingClientRect().top;
			var push = headerH - sentinelTop;
			if (push < 0) push = 0;

			clone.classList.toggle('is-stick', push >= headerH);
		};
	}

	/* ── Collapsed toggle ── */
	function watchCollapsed() {
		$(document).on('click', '.longFeaturesSwitch button', function () {
			if (!clone) return;
			var lfEl = document.getElementById('longFeatures');
			if (!lfEl) return;
			setTimeout(function () {
				if (lfEl.classList.contains('collapsed')) {
					clone.classList.add('lf-hidden');
				} else {
					clone.classList.remove('lf-hidden');
					syncColWidths();
				}
			}, 50);
		});
	}

	/* ── Init ── */
	$(function () {
		if (mql.matches) createClone();

		if (mql.addEventListener) {
			mql.addEventListener('change', onResize);
		} else if (mql.addListener) {
			mql.addListener(onResize);
		}

		window.addEventListener('resize', onResize);

		patchCalcAndApply();
		watchCollapsed();
	});

})();